// extracted by mini-css-extract-plugin
export default {"main":"FormDatePeriodInput_main__eRUVI","label":"FormDatePeriodInput_label__soWDw","row":"FormDatePeriodInput_row__IJtoR"};